import React from 'react';

import pluralize from 'pluralize';

import SelectAllCheckbox from './select_all_checkbox';

import type { Props } from './types';
import { Button } from 'react-bootstrap-5';

export default function MapListHeaderEdgeCrm({
  toggleSelectAll,
  totalCount,
  totalLabel,
  ...props
}: Props) {
  return (
    <div className="d-flex gap-2 bg-white px-3 py-2 border-bottom align-items-center">
      <SelectAllCheckbox toggleSelectAll={toggleSelectAll} {...props} />
      <div className="flex-fill">
        <Button size="sm" variant="ghost" onClick={toggleSelectAll}>
          Select all
        </Button>
      </div>
      <div className="fs-small">{pluralize(totalLabel, totalCount, true)}</div>
    </div>
  );
}
